import React from 'react'
import { BsPersonCircle } from 'react-icons/bs'

const MyProfile = ({ className = '', userName = '' }) => (
  <div aria-label={userName} className={`${className} flex items-center focus:outline-none`}>
    <p className="inline-block lg:font-normal lg:text-sm maxSm:order-last maxSm:ml-2 maxSM:text-lg maxSM:font-medium">
      {userName}
    </p>
    <BsPersonCircle className="inline w-6 h-6 ml-2 text-white maxSm:ml-0" />
  </div>
)

export default MyProfile
